import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import appRoutes from "../../routes/appRoutes";

import ICPhoneDisplay from "../../components/phoneDisplay";

const ViewLegalPage = props => (
  <div className="view-ticket-container">
    <div className="d-flex flex-row flex-wrap justify-content-between">
      <h3>Legal</h3>
      <form className="w-100 mt-4">
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Email Address:</p>
          <p className="col-sm-5">
            {props.serverConstants ? props.serverConstants.email : ""}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Phone Number:</p>
          <p className="col-sm-5">
            <ICPhoneDisplay
              className="legal-phone-no"
              value={
                props.serverConstants ? props.serverConstants.phoneNumber : ""
              }
            />
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Instant Consult Terms & Conditions:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.terms && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.terms && (
              <a
                className="legal-link"
                href={props.serverConstants ? props.serverConstants.terms : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>

        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Instant Extras Terms & Conditions:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.instantExtraTermsConditions && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.instantExtraTermsConditions && (
              <a
                className="legal-link"
                href={props.serverConstants ? props.serverConstants.instantExtraTermsConditions : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>

        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Doctor Service Agreement:</p>
          <p className="col-sm-5">
            {props.serverConstants &&
              !props.serverConstants.serviceAgreement && <span>-</span>}
            {props.serverConstants && props.serverConstants.serviceAgreement && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.serviceAgreement
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">
            Doctor Verification Process:
          </p>
          <p className="col-sm-5">
            {props.serverConstants &&
              !props.serverConstants.validationProcess && <span>-</span>}
            {props.serverConstants && props.serverConstants.validationProcess && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.validationProcess
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Privacy Policy:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.privacyPolicy && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.privacyPolicy && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.privacyPolicy
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">Good Practice & Safe Prescribing Policy Book:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.goodPracticePolicy && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.goodPracticePolicy && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.goodPracticePolicy
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">My Health Record Security and Access Policy:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.myHealthRecordSecurityAndAccessPolicy && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.myHealthRecordSecurityAndAccessPolicy && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.myHealthRecordSecurityAndAccessPolicy
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <div className="form-group row">
          <p className="col-sm-4 font-weight-bold">My Health Record Training Policy:</p>
          <p className="col-sm-5">
            {props.serverConstants && !props.serverConstants.myHealthRecordTrainingPolicy && (
              <span>-</span>
            )}
            {props.serverConstants && props.serverConstants.myHealthRecordTrainingPolicy && (
              <a
                className="legal-link"
                href={
                  props.serverConstants
                    ? props.serverConstants.myHealthRecordTrainingPolicy
                    : ""
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF
              </a>
            )}
          </p>
        </div>
        <br />
        <p>
          <Link
            style={{ width: "40px" }}
            className="insta-button-primary"
            to={appRoutes.editLegal}
          >
            Edit
          </Link>
        </p>
      </form>
    </div>
  </div>
);

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
});

export default connect(mapStateToProps, null)(ViewLegalPage);
